import { OverlayModule } from '@angular/cdk/overlay';
import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMatPopoverModule } from '@exalif/ngx-mat-popover';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { ChartModule } from 'angular2-chartjs';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBrazil } from 'ng-brazil';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ChartsModule } from 'ng2-charts';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { TourMatMenuModule } from 'ngx-tour-md-menu';
// router
import { AppRoutingModule, RoutingComponents } from './app-routing.module';
// generic components
import { AppComponent } from './app.component';
import { ColaboradorFinanceiroListComponent } from './components/portal/administrativo/gestao-beneficios/colaborador-financeiro-list/colaborador-financeiro-list.component';
import { GestaoBeneficiosComponent } from './components/portal/administrativo/gestao-beneficios/gestao-beneficios.component';
import { ResgateBeneficioComponent } from './components/portal/administrativo/gestao-beneficios/resgate-beneficio/resgate-beneficio.component';
import { TransfereBeneficioComponent } from './components/portal/administrativo/gestao-beneficios/transfere-beneficio/transfere-beneficio.component';
import { GestorAceitoListComponent } from './components/portal/administrativo/gestor/gestor-aceito-list/gestor-aceito-list.component';
import { ColaboradorBeneficiosComponent } from './components/portal/cadastro/colaborador/colaborador-beneficios/colaborador-beneficios.component';
import { ColaboradorListComponent } from './components/portal/cadastro/colaborador/colaborador-list/colaborador-list.component';
import { CondutorCreateComponent } from './components/portal/cadastro/condutor/condutor-create/condutor-create.component';
import { CondutorEditComponent } from './components/portal/cadastro/condutor/condutor-edit/condutor-edit.component';
import { CondutorListComponent } from './components/portal/cadastro/condutor/condutor-list/condutor-list.component';
import { CondutorComponent } from './components/portal/cadastro/condutor/condutor.component';
import { GrupoAddCollaboratorComponent } from './components/portal/cadastro/grupo/grupo-add-collaborator/grupo-add-collaborator.component';
import { GrupoBeneficiosComponent } from './components/portal/cadastro/grupo/grupo-beneficios/grupo-beneficios.component';
import { GrupoCreateTimelineComponent } from './components/portal/cadastro/grupo/grupo-create-timeline/grupo-create-timeline.component';
import { GrupoCreateComponent } from './components/portal/cadastro/grupo/grupo-create/grupo-create.component';
import { GrupoDetalheComponent } from './components/portal/cadastro/grupo/grupo-detalhe/grupo-detalhe.component';
import { GrupoListCollaboratorComponent } from './components/portal/cadastro/grupo/grupo-list-collaborator/grupo-list-collaborator.component';
import { GrupoListComponent } from './components/portal/cadastro/grupo/grupo-list/grupo-list.component';
import { GrupoRegrasComponent } from './components/portal/cadastro/grupo/grupo-regras/grupo-regras.component';
import { GrupoResumoComponent } from './components/portal/cadastro/grupo/grupo-resumo/grupo-resumo.component';
import { GrupoComponent } from './components/portal/cadastro/grupo/grupo.component';
import { VeiculosCondutoresAddComponent } from './components/portal/cadastro/veiculos/veiculos-condutores/veiculos-condutores-add/veiculos-condutores-add.component';
import { VeiculosCondutoresListComponent } from './components/portal/cadastro/veiculos/veiculos-condutores/veiculos-condutores-list/veiculos-condutores-list.component';
import { VeiculosCondutoresComponent } from './components/portal/cadastro/veiculos/veiculos-condutores/veiculos-condutores.component';
import { VeiculosCreateComponent } from './components/portal/cadastro/veiculos/veiculos-create/veiculos-create.component';
import { VeiculosEditComponent } from './components/portal/cadastro/veiculos/veiculos-edit/veiculos-edit.component';
import { VeiculosListComponent } from './components/portal/cadastro/veiculos/veiculos-list/veiculos-list.component';
import { VeiculosVincularCartaoComponent } from './components/portal/cadastro/veiculos/veiculos-vincular-cartao/veiculos-vincular-cartao.component';
import { VeiculosComponent } from './components/portal/cadastro/veiculos/veiculos.component';
import { CartoesFisicosListComponent } from './components/portal/cartoes-fisicos/cartoes-fisicos-list/cartoes-fisicos-list.component';
import { CartoesFisicosPedidoDetalhesComponent } from './components/portal/cartoes-fisicos/cartoes-fisicos-pedido-detalhes/cartoes-fisicos-pedido-detalhes.component';
import { CartoesFisicosPedidoComponent } from './components/portal/cartoes-fisicos/cartoes-fisicos-pedido/cartoes-fisicos-pedido.component';
import { CartoesFisicosComponent } from './components/portal/cartoes-fisicos/cartoes-fisicos.component';
import { ComprasAnterioresComponent } from './components/portal/compras/minhas-compras/minhas-compras-list/compras-anteriores/compras-anteriores.component';
import { ComprasEmAndamentoComponent } from './components/portal/compras/minhas-compras/minhas-compras-list/compras-em-andamento/compras-em-andamento.component';
import { ComprasSalvasComponent } from './components/portal/compras/minhas-compras/minhas-compras-list/compras-salvas/compras-salvas.component';
import { NovacompraArquivoConfirmarComponent } from './components/portal/compras/nova-compra/nova-compra-arquivo-confirmar/nova-compra-arquivo-confirmar.component';
import { NovacompraConfirmarComponent } from './components/portal/compras/nova-compra/nova-compra-confirmar/nova-compra-confirmar.component';
import { NovacompraGrupoComponent } from './components/portal/compras/nova-compra/nova-compra-grupo/nova-compra-grupo.component';
import { UploadArquivoComponent } from './components/portal/compras/nova-compra/upload-arquivo/upload-arquivo.component';
import { CartaoStatusListComponent } from './components/portal/financeiro/cartao/cartao-status-list/cartao-status-list.component';
import { CartaoComponent } from './components/portal/financeiro/cartao/cartao.component';
import { DepositosPagamentosComponent } from './components/portal/financeiro/depositos-pagamentos/depositos-pagamentos.component';
import { BoletoComponent } from './components/portal/financeiro/depositos/boleto/boleto.component';
import { DepositosComponent } from './components/portal/financeiro/depositos/depositos.component';
import { TipoDepositoComponent } from './components/portal/financeiro/depositos/tipo-deposito/tipo-deposito.component';
import { TransferenciaComponent } from './components/portal/financeiro/depositos/transferencia/transferencia.component';
import { ExtratoLogListComponent } from './components/portal/financeiro/extrato-log/extrato-log-list/extrato-log-list.component';
import { ExtratoLogComponent } from './components/portal/financeiro/extrato-log/extrato-log.component';
import { ExtratoCompraListComponent } from './components/portal/financeiro/extrato-pedido/extrato-compra-list/extrato-compra-list.component';
import { ExtratoCompraComponent } from './components/portal/financeiro/extrato-pedido/extrato-compra.component';
import { ExtratoListComponent } from './components/portal/financeiro/extrato/extrato-list/extrato-list.component';
import { ExtratoComponent } from './components/portal/financeiro/extrato/extrato.component';
import { SaldoAlocadoCreateComponent } from './components/portal/financeiro/saldo-alocado/saldo-alocado-create/saldo-alocado-create.component';
import { SaldoAlocadoEditComponent } from './components/portal/financeiro/saldo-alocado/saldo-alocado-edit/saldo-alocado-edit.component';
import { SaldoAlocadoListComponent } from './components/portal/financeiro/saldo-alocado/saldo-alocado-list/saldo-alocado-list.component';
import { SaldoAlocadoComponent } from './components/portal/financeiro/saldo-alocado/saldo-alocado.component';
import { AcessoRapidoComponent } from './components/portal/home/acesso-rapido/acesso-rapido.component';
import { ChartComponent } from './components/portal/home/chart/chart.component';
import { EstatisticasComponent } from './components/portal/home/estatisticas/estatisticas.component';
import { SaldoComponent } from './components/portal/home/saldo/saldo.component';
import { UltimosPedidosComponent } from './components/portal/home/ultimos-pedidos/ultimos-pedidos.component';
import { NotificacaoListComponent } from './components/portal/notificacao/notificacao-list/notificacao-list.component';
import { NotificacaoComponent } from './components/portal/notificacao/notificacao.component';
import { ConsumoComponent } from './components/portal/relatorio-log/consumo/consumo.component';
import { RelatorioLogComponent } from './components/portal/relatorio-log/relatorio-log.component';
import { ValidadeCnhComponent } from './components/portal/relatorio-log/validade-cnh/validade-cnh.component';
import { CreditoRelatorioComponent } from './components/portal/relatorio/credito-relatorio/credito-relatorio.component';
import { ExtratoRelatorioComponent } from './components/portal/relatorio/extrato-relatorio/extrato-relatorio.component';
import { FavorecidoConsolidadaComponent } from './components/portal/relatorio/favorecido-consolidada/favorecido-consolidada.component';
import { RecargasRelatorioComponent } from './components/portal/relatorio/recargas-relatorio/recargas-relatorio.component';
import { RelatorioFavorecidoComponent } from './components/portal/relatorio/relatorio-favorecido/relatorio-favorecido.component';
import { RelatorioComponent } from './components/portal/relatorio/relatorio.component';
import { SaldoConsolidadoComponent } from './components/portal/relatorio/saldo-consolidado/saldo-consolidado.component';
import { SaldoDetalhadoComponent } from './components/portal/relatorio/saldo-detalhado/saldo-detalhado.component';
import { SituacaoCadastroComponent } from './components/portal/relatorio/situacao-cadastro/situacao-cadastro.component';
import { SituacaoCartaoComponent } from './components/portal/relatorio/situacao-cartao/situacao-cartao.component';
import { SituacaoSolicitacaoCartaoComponent } from './components/portal/relatorio/situacao-solicitacao-cartao/situacao-solicitacao-cartao.component';
import { ResetarSenhaComponent } from './components/portal/resetar-senha/resetar-senha.component';
import { VisualizarBoletoComponent } from './components/portal/visualizar-boleto/visualizar-boleto.component';
import { PortadorVincularCartaoComponent } from './components/portal/cadastro/portador/portador-vincular-cartao/portador-vincular-cartao.component';

// directives
import { ExpandMenuDirective } from './directives/expand-menu.directive';
import { FileUploadDirective } from './directives/file-upload.directive';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { NewPurchaseWrapper } from './react/wrappers/NewPurchaseWrapper';
import { KycStatusComponent } from './shared/components/kyc-status/kyc-status.component';
import { NewAlertModule } from './shared/components/new-alert/new-alert.module';
import { NumberCounterComponent } from './shared/components/number-counter/number-counter.component';
// interceptors
import { RequestInterceptor } from './shared/helpers/interceptors/request.interceptor';
// pipe
import { MycurrencyPipe } from './shared/pipes/custom.currencypipe';
import { MaskCEPPipe } from './shared/pipes/masks/mask-cep.pipe';
import { ModalFilterColaboradorPeriodoPipe } from './shared/pipes/modal-filter-colaborador-periodo.pipe';
import { ModalFilterColaboradorPipe } from './shared/pipes/modal-filter-colaborador.pipe';
import { ModalFilterPipe } from './shared/pipes/modal-filter.pipe';
import { ProductCategoryPipe } from './shared/pipes/product-category.pipe';
import { SafePipe } from './shared/pipes/safe.pipe';
import { SearchFilterColaboradorPipe } from './shared/pipes/search-filter-colaborador.pipe';
import { SearchFilterPedidoPeriodoPipe } from './shared/pipes/search-filter-pedido-periodo.pipe';
import { SearchFilterPipe } from './shared/pipes/search-filter.pipe';
import { SearchPedidosSalvosPipe } from './shared/pipes/search-pedidos-salvos.pipe';
import { TextFixedPipe } from './shared/pipes/text-fixed.pipe';
import { ColaboradorArquivoConfirmarComponent } from './components/portal/cadastro/colaborador/colaborador-arquivo-confirmar/colaborador-arquivo-confirmar.component';
import { ComprasRascunhoComponent } from './components/portal/compras/minhas-compras/minhas-compras-list/compras-rascunho/compras-rascunho.component';
import { TransacaoSaldoAlocadoComponent } from './components/portal/relatorio-despesas/transacao-saldo-alocado/transacao-saldo-alocado.component';
import { RelatorioDespesasComponent } from './components/portal/relatorio-despesas/relatorio-despesas.component';
import { CreditosComponent } from './components/portal/relatorio-despesas/creditos/creditos.component';
import { DoacoesComponent } from './components/portal/home/doacoes/doacoes.component';



registerLocaleData(ptBr);

export const MY_DATE_FORMATS = {
    parse: {
      dateInput: 'DD/MM/YYYY',
    },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY'
    },
};

@NgModule({
    declarations: [
        AppComponent,
        RoutingComponents,
        ExpandMenuDirective,
        OnlyNumberDirective,
        SearchFilterPipe,
        ModalFilterPipe,
        SearchFilterColaboradorPipe,
        MaskCEPPipe,
        SafePipe,
        MycurrencyPipe,
        SearchFilterPedidoPeriodoPipe,
        ModalFilterColaboradorPipe,
        ModalFilterColaboradorPeriodoPipe,
        ProductCategoryPipe,
        ComprasAnterioresComponent,
        ComprasSalvasComponent,
        ComprasEmAndamentoComponent,
        UploadArquivoComponent,
        SearchPedidosSalvosPipe,
        UltimosPedidosComponent,
        DoacoesComponent,
        AcessoRapidoComponent,
        EstatisticasComponent,
        GestaoBeneficiosComponent,
        GestorAceitoListComponent,
        FileUploadDirective,
        NovacompraArquivoConfirmarComponent,
        NovacompraConfirmarComponent,
        ColaboradorFinanceiroListComponent,
        ResgateBeneficioComponent,
        TransfereBeneficioComponent,
        GestorAceitoListComponent,
        ExtratoCompraComponent,
        ExtratoCompraListComponent,
        DepositosComponent,
        TipoDepositoComponent,
        TransferenciaComponent,
        BoletoComponent,
        VisualizarBoletoComponent,
        ColaboradorBeneficiosComponent,
        TextFixedPipe,
        SaldoComponent,
        ChartComponent,
        GrupoListComponent,
        GrupoComponent,
        GrupoCreateComponent,
        GrupoCreateTimelineComponent,
        GrupoAddCollaboratorComponent,
        GrupoListCollaboratorComponent,
        GrupoBeneficiosComponent,
        GrupoRegrasComponent,
        GrupoResumoComponent,
        GrupoDetalheComponent,
        NovacompraGrupoComponent,
        CartaoComponent,
        CartaoStatusListComponent,
        ExtratoComponent,
        ExtratoListComponent,
        DepositosPagamentosComponent,
        ColaboradorListComponent,
        NotificacaoComponent,
        NotificacaoListComponent,
        RelatorioComponent,
        RelatorioFavorecidoComponent,
        FavorecidoConsolidadaComponent,
        SaldoDetalhadoComponent,
        SaldoConsolidadoComponent,
        ExtratoRelatorioComponent,
        CreditoRelatorioComponent,
        RecargasRelatorioComponent,
        SituacaoCadastroComponent,
        SituacaoCartaoComponent,
        NumberCounterComponent,
        CartoesFisicosComponent,
        CartoesFisicosListComponent,
        CartoesFisicosPedidoComponent,
        CartoesFisicosPedidoDetalhesComponent,
        SituacaoSolicitacaoCartaoComponent,
        ResetarSenhaComponent,
        VeiculosComponent,
        VeiculosListComponent,
        VeiculosCreateComponent,
        VeiculosEditComponent,
        VeiculosCondutoresComponent,
        VeiculosCondutoresListComponent,
        VeiculosCondutoresAddComponent,
        VeiculosVincularCartaoComponent,
        KycStatusComponent,
        SaldoAlocadoComponent,
        SaldoAlocadoListComponent,
        SaldoAlocadoCreateComponent,
        CondutorComponent,
        CondutorListComponent,
        CondutorEditComponent,
        CondutorCreateComponent,
        SaldoAlocadoEditComponent,
        ExtratoLogComponent,
        ExtratoLogListComponent,
        RelatorioLogComponent,
        ValidadeCnhComponent,
        ConsumoComponent,
        NewPurchaseWrapper,
        ColaboradorArquivoConfirmarComponent,
        ComprasRascunhoComponent,
        PortadorVincularCartaoComponent,
        TransacaoSaldoAlocadoComponent,
        RelatorioDespesasComponent,
        CreditosComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        TextMaskModule,
        NgBrazil,
        NgbModule,
        OverlayModule,
        NgxPaginationModule,
        //MyDatePickerModule,
        NgHttpLoaderModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        ChartsModule,
        ZXingScannerModule,
        AngularMyDatePickerModule,
        CurrencyMaskModule,
        NewAlertModule,
        ChartModule,
        SlickCarouselModule,
        TourMatMenuModule.forRoot(),
        BrowserAnimationsModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatSidenavModule,
        MatTooltipModule,
        MatSelectModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatInputModule,
        MatFormFieldModule,
        MatExpansionModule,
        NgxMatSelectSearchModule,
        MatButtonToggleModule,
        MatStepperModule,
        MatCheckboxModule,
        NgxMatPopoverModule,
        MatTabsModule,
        MatSlideToggleModule,
        MomentDateModule,
        NgxSkeletonLoaderModule,
        MatProgressBarModule
    ],
    providers: [
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        { provide: LOCALE_ID, useValue: 'pt' },
        // { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        ModalFilterColaboradorPipe,
        ModalFilterColaboradorPeriodoPipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
